document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

// =============================================================================
// Imports
// =============================================================================

import { gsap } from "gsap";

// =============================================================================
// Menu
// =============================================================================

let menuToggleExists = document.querySelector('#menu-toggle');
let menuItemsExists = document.querySelector('#nav-primary .menu-item');

import { menuToggle, menuHovers } from './core/menu';
if (menuToggleExists) {
	menuToggle();
}

if (menuItemsExists) {
	menuHovers();
}


// =============================================================================
// Animation
// =============================================================================

let animElemsExist = document.querySelector('[data-anim-elem]')
let parallaxExists = document.querySelector('.parallax-bg')
let heroExists = document.querySelector('#hero-section')
let scrollCurveExists = document.querySelector('#scroll-curve')
let pullStarExists = document.querySelector('.pull-star')
let bgElemExists = document.querySelector('.bg-elem')

import { generalAnimations, parallaxBg, homeAnimations, heroAnimation, scrollCurveAnimation, pullStarAnimation, bgElemsAnimation, blogFeedAnimation, singlePostAnimation } from './core/animation';

if (animElemsExist) {
  // generalAnimations()
}

if (heroExists) {
  heroAnimation()
}

if (parallaxExists) {
  parallaxBg()
}

if (scrollCurveExists) {
  scrollCurveAnimation()
}

if (pullStarExists) {
  pullStarAnimation()
}

if (bgElemExists) {
  bgElemsAnimation()
}

homeAnimations()

// =============================================================================
// Blog Feed
// =============================================================================

let blogFeedExists = document.querySelector('.blog-feed-grid')

if (blogFeedExists) {
  blogFeedAnimation()
}

// =============================================================================
// Single Post
// =============================================================================

let singlePostExists = document.querySelector('.single-post-content-inner')

if (singlePostExists) {
  singlePostAnimation()
}